/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
import React, { useState, useEffect } from "react";
import UploadFile from "./UploadFile";
import Stack from "@mui/material/Stack";
import { Typography, Alert, Button, CircularProgress } from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import CloseIcon from "@mui/icons-material/Close";
import useDocumentacio from "../../../hooks/useDocumentacio";
import Tipografia from "../Tipografia";

const styleUploadFiles = {
  backgroundColor: "#D3D3D3",
  borderWidth: "2px",
  borderRadius: "2px",
  marginBottom: 1,
};

function UploadSamplesFile() {
  
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const { uploadFiles } = useDocumentacio();
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState(false);
  const [sizeFiles, setSizeFiles] = useState(0);

  const onDrop = (docs) => {
    // Verificamos si hay archivos con el mismo nombre
    const existingFiles = files.filter(existingDoc =>
      docs.some(doc => doc.name === existingDoc.name)
    );
  
    if (existingFiles.length > 0) {
      // Elimina los documentos ya existentes
      const newDocs = docs.filter(doc =>
        !existingFiles.some(existingDoc => existingDoc.name === doc.name)
      );
      setFiles((actualDocs) => [...actualDocs, ...newDocs]);
    } else {
      setFiles((actualDocs) => [...actualDocs, ...docs]);
    }
  };

  const onDeleteFile = (file) => {
    setFiles((actualDocs) => {
      return actualDocs.filter((doc) => {
        return doc.name !== file.name;
      });
    });
  };

  const onSendFiles = async () => {
    setIsLoading(true);

    try {
        await uploadFiles(files)
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
  };

  useEffect(() => {
   
    const maxTotalSizeInBytes = 30 * 1024 * 1024; // 30 MB
    const totalSizeInBytes  = files.reduce((acc, file) => acc + file.size, 0);
    const totalSizeInMB = Math.round(totalSizeInBytes / (1024 * 1024));

    setSizeFiles(totalSizeInMB);
    if(files.length>5){
      setErrorMessage(`Només es permeten fins a 5 fitxers.`);
      setError(true)
    }
    else if (totalSizeInBytes  > maxTotalSizeInBytes) {
      setErrorMessage(`S'ha superat el límit de 30 MB en els fitxers adjunts.`);
      setError(true)
    } 
    else{
      setError(false)
    }
    
  }, [files]);

  return (
    <div>
      {error && (
        <p>
          <Alert severity="error" sx={{ marginTop: 2 }}>
          {errorMessage}
          </Alert>
        </p>
      )}
      <UploadFile onDrop={onDrop}/>
      <div>
      <Tipografia
        key={2}
        sx={{
          color: files.length > 5 ? "#900000" : "#5d5760",
          fontWeight: "bold",
        }}
        titol={`Total fitxers ${files.length}/5`}
      />
      </div>
      <div>

      <Tipografia
        key={2}
        sx={{
          color: sizeFiles > 30 ? "#900000" : "#5d5760",
          fontWeight: "bold",
        }}
        titol={`Total ${sizeFiles}MB/30MB`}
      />
      </div>
      
      {files.map((file) => (
        <div style={styleUploadFiles} key={file.name}>
          <Stack direction="row">
            <Stack direction="row" spacing={2}>
              <ArrowRightIcon fontSize="small" />
              <Typography variant="body1">{file.name}</Typography>
            </Stack>
            <Stack marginLeft="auto">
              <CloseIcon
                sx={{ color: "red" }}
                onClick={() => onDeleteFile(file)}
              ></CloseIcon>
            </Stack>
          </Stack>
        </div>
      ))}

{isLoading ? (
  <CircularProgress />
) : (
  <>
                    
      {files.length > 0 && (
        
        <Button
          size={"small"}
          variant="contained"
          disabled={error}
          sx={{
            marginTop: 3,
            color: "white",
            backgroundColor: "#900000",
            justifyContent: "center",
            ":hover": { backgroundColor: "#900000" },
          }}
          onClick={() => onSendFiles()}
        >
          Enviar
          </Button>
    )}
  </>
)}
                
   </div>
  );
}

export default UploadSamplesFile;
